<template>
    <main-layout>
        <template #breadcrumbs>
            <span class="union-icon">
                <i class="feather-tag"></i>
            </span>
            <span class="repo-chart-title">
                Repositories
            </span>
        </template>
        <template #pageTitle>
            <h2 class="mb-1">Helm Repositories</h2>
            <span class="sm-text">Here is the list of your repositories</span>
        </template>
        <template #headerButton>
            <inertia-link :href="route('teams.create')" as="button" class="btn btn-style btn-primary">
                <i class="demo-icon icon-union2 lg-icon"></i>
                <span>CREATE REPOSITORY</span>
            </inertia-link>
        </template>
        <template #search v-if="false">
            <input type="text" placeholder="Search Repository" class="box-input-style form-control" >
            <button class="search-icon"><i class="feather-search"></i></button>
        </template>

        <div v-if="repoList.length > 0">
            <div class="pt-3 pb-4">
                <div class="repository-cards-list pt-0">
                    <div class="row">
                        <div v-for="repo in repoList" class="col-xl-3 col-lg-4 col-md-6" :key="repo.id">
                            <inertia-link :href="route('repository.view', {team: repo})">
                                <div class="repository-card-style">
                                    <h5 class="repo-card-title text-black">{{repo.name}}</h5>
                                    <p class="text-black repo-card-name" style="font-family: 'Fira Code'; font-size: 12px; color: #777">
                                        {{ route('repository.view', {team: repo}).replace('http://', '').replace('https://', '') }}
                                    </p>
                                    <p class="text-black repo-card-name">
                                        <i class="feather-user" style="color: #555;"/> {{ repo.owner.name }}
                                    </p>
                                    <div class="row g-2">
                                        <div class="col-4">
                                            <div class="repo-card-icon-text">
                                                <i class="icon-vector"></i>
                                                <span class="icon-text">{{ counts[repo.id].charts }}</span>
                                            </div>
                                        </div>
                                        <div class="col-4">
                                            <div class="repo-card-icon-text">
                                                <i class="feather-users"></i>
                                                <span class="icon-text">{{ counts[repo.id].users }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </inertia-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <MainSection/>
        </div>
    </main-layout>
</template>

<script>
    import MainLayout from '@/Layouts/MainLayout'
    import MainSection from '@/Layouts/RepositoryLayouts/MainSection'

    export default {
        props: ['repoList', 'counts', 'user_name'],

        components: {
            MainLayout,
            MainSection,
        },
    }
</script>
